export default {
  "zh_TW": {
    "marketSummary": "Bitcoin 市場摘要",
    "trend24h": "24 小時走勢",
    "past24h": "過去 24 小時",
    "candleSummary": "BTC 最近 48 根 30 分鐘收盤價走勢",
    "historyPrice": "查看 BTC 歷史價格",
    "priceAt": "{time}，價格 {price}",
    "scrubHint": "拖動或使用方向鍵查看價格",
    "chartUnavailable": "走勢資料暫時未能載入",
    "chartLoading": "正在載入走勢…",
    "btcRatio": "BTC 多空比",
    "ratioShare": "多 {long}% · 空 {short}%",
    "marketSentiment": "市場情緒",
    "marketFocus": "市場焦點",
    "exploreChains": "探索公鏈",
    "topAccountUnavailable": "暫無 {chain} 大戶帳戶比數據",
    "topPositionUnavailable": "暫無 {chain} 大戶持倉比數據",
    "previousValue": "前值",
    "actualValue": "公布值",
    "usdtData": "USDT 專項數據",
    "relatedStablecoins": "相關穩定幣",
    "otcAverage": "場外均價",
    "exchangeRate": "匯率",
    "premiumRate": "溢價率",
    "copyFailed": "複製失敗",
    "month": "個月",
    "day": "天",
    "hour": "小時",
    "minute": "分鐘",
    "second": "秒",
    "back": "返回",
    "apiKey": "API 金鑰",
    "secretKey": "私密金鑰",
    "passphrase": "API 密碼",
    "tradingChart": "DEXTools 交易圖表",
    "requestFailed": "請求失敗，請重試",
    "networkError": "無法連線，請檢查網絡後重試",
    "timeout": "連線逾時，請重試",
    "sessionExpired": "登入已失效，請重新登入",
    "walletDisconnected": "已斷開錢包連線",
    "connectWalletFirst": "請先連接錢包",
    "invalidAmount": "請輸入有效金額",
    "positiveAmount": "金額必須大於 0",
    "invalidSwap": "兌換資料無效，請重新取得報價",
    "swapFailed": "兌換失敗，請檢查交易狀態",
    "serviceUnavailable": "服務暫時無法使用",
    "tokenInfoFailed": "無法取得代幣資料",
    "walletNoAccount": "錢包未傳回 Solana 帳戶",
    "walletUnsupported": "此錢包不支援簽署及傳送交易",
    "walletNoSignature": "錢包未傳回交易簽章，請檢查交易狀態",
    "klineTime": "時間：",
    "klineOpen": "開：",
    "klineHigh": "高：",
    "klineLow": "低：",
    "klineClose": "收：",
    "klineVolume": "成交量：",
    "klineTurnover": "成交額：",
    "klineChange": "漲跌幅：",
    "walletLink": "錢包連結"
  },
  "zh_CN": {
    "marketSummary": "Bitcoin 市场摘要",
    "trend24h": "24 小时走势",
    "past24h": "过去 24 小时",
    "candleSummary": "BTC 最近 48 根 30 分钟收盘价走势",
    "historyPrice": "查看 BTC 历史价格",
    "priceAt": "{time}，价格 {price}",
    "scrubHint": "拖动或使用方向键查看价格",
    "chartUnavailable": "走势数据暂时无法加载",
    "chartLoading": "正在加载走势…",
    "btcRatio": "BTC 多空比",
    "ratioShare": "多 {long}% · 空 {short}%",
    "marketSentiment": "市场情绪",
    "marketFocus": "市场焦点",
    "exploreChains": "探索公链",
    "topAccountUnavailable": "暂无 {chain} 大户账户比数据",
    "topPositionUnavailable": "暂无 {chain} 大户持仓比数据",
    "previousValue": "前值",
    "actualValue": "公布值",
    "usdtData": "USDT 专项数据",
    "relatedStablecoins": "相关稳定币",
    "otcAverage": "场外均价",
    "exchangeRate": "汇率",
    "premiumRate": "溢价率",
    "copyFailed": "复制失败",
    "month": "个月",
    "day": "天",
    "hour": "小时",
    "minute": "分钟",
    "second": "秒",
    "back": "返回",
    "apiKey": "API 密钥",
    "secretKey": "私密密钥",
    "passphrase": "API 密码",
    "tradingChart": "DEXTools 交易图表",
    "requestFailed": "请求失败，请重试",
    "networkError": "无法连接，请检查网络后重试",
    "timeout": "连接超时，请重试",
    "sessionExpired": "登录已失效，请重新登录",
    "walletDisconnected": "已断开钱包连接",
    "connectWalletFirst": "请先连接钱包",
    "invalidAmount": "请输入有效金额",
    "positiveAmount": "金额必须大于 0",
    "invalidSwap": "兑换数据无效，请重新获取报价",
    "swapFailed": "兑换失败，请检查交易状态",
    "serviceUnavailable": "服务暂时无法使用",
    "tokenInfoFailed": "无法获取代币信息",
    "walletNoAccount": "钱包未返回 Solana 账户",
    "walletUnsupported": "此钱包不支持签署和发送交易",
    "walletNoSignature": "钱包未返回交易签名，请检查交易状态",
    "klineTime": "时间：",
    "klineOpen": "开：",
    "klineHigh": "高：",
    "klineLow": "低：",
    "klineClose": "收：",
    "klineVolume": "成交量：",
    "klineTurnover": "成交额：",
    "klineChange": "涨跌幅：",
    "walletLink": "钱包链接"
  },
  "en_US": {
    "marketSummary": "Bitcoin market summary",
    "trend24h": "24h trend",
    "past24h": "Past 24 hours",
    "candleSummary": "BTC closing prices: last 48 half-hour candles",
    "historyPrice": "View BTC price history",
    "priceAt": "{time}, price {price}",
    "scrubHint": "Drag or use arrow keys to inspect prices",
    "chartUnavailable": "Chart data is temporarily unavailable",
    "chartLoading": "Loading chart…",
    "btcRatio": "BTC long/short ratio",
    "ratioShare": "Long {long}% · Short {short}%",
    "marketSentiment": "Market sentiment",
    "marketFocus": "Market highlights",
    "exploreChains": "Explore chains",
    "topAccountUnavailable": "No top-trader account ratio data for {chain}",
    "topPositionUnavailable": "No top-trader position ratio data for {chain}",
    "previousValue": "Previous",
    "actualValue": "Actual",
    "usdtData": "USDT data",
    "relatedStablecoins": "Related stablecoins",
    "otcAverage": "Average OTC price",
    "exchangeRate": "Exchange rate",
    "premiumRate": "Premium rate",
    "copyFailed": "Could not copy",
    "month": "mo",
    "day": "d",
    "hour": "h",
    "minute": "min",
    "second": "s",
    "back": "Back",
    "apiKey": "API key",
    "secretKey": "Secret key",
    "passphrase": "Passphrase",
    "tradingChart": "DEXTools trading chart",
    "requestFailed": "Request failed. Please try again.",
    "networkError": "Unable to connect. Check your network and try again.",
    "timeout": "The request timed out. Please try again.",
    "sessionExpired": "Your session has expired. Please log in again.",
    "walletDisconnected": "Wallet disconnected",
    "connectWalletFirst": "Connect your wallet first",
    "invalidAmount": "Enter a valid amount",
    "positiveAmount": "Amount must be greater than zero",
    "invalidSwap": "Invalid swap data. Request a new quote.",
    "swapFailed": "Swap failed. Check the transaction status.",
    "serviceUnavailable": "Service temporarily unavailable",
    "tokenInfoFailed": "Could not load token information",
    "walletNoAccount": "The wallet did not return a Solana account",
    "walletUnsupported": "This wallet cannot sign and send transactions",
    "walletNoSignature": "No transaction signature returned. Check the transaction status.",
    "klineTime": "Time:",
    "klineOpen": "Open:",
    "klineHigh": "High:",
    "klineLow": "Low:",
    "klineClose": "Close:",
    "klineVolume": "Volume:",
    "klineTurnover": "Turnover:",
    "klineChange": "Change:",
    "walletLink": "Wallet link"
  },
  "ja_JP": {
    "marketSummary": "Bitcoin 市場概要",
    "trend24h": "24時間の推移",
    "past24h": "過去24時間",
    "candleSummary": "BTC終値：直近48本の30分足",
    "historyPrice": "BTCの価格履歴を表示",
    "priceAt": "{time}、価格 {price}",
    "scrubHint": "ドラッグまたは矢印キーで価格を確認",
    "chartUnavailable": "チャートデータを取得できません",
    "chartLoading": "チャートを読み込み中…",
    "btcRatio": "BTCロング・ショート比率",
    "ratioShare": "ロング {long}% · ショート {short}%",
    "marketSentiment": "市場センチメント",
    "marketFocus": "市場の注目情報",
    "exploreChains": "チェーンを探す",
    "topAccountUnavailable": "{chain}の大口アカウント比率データはありません",
    "topPositionUnavailable": "{chain}の大口ポジション比率データはありません",
    "previousValue": "前回値",
    "actualValue": "発表値",
    "usdtData": "USDTデータ",
    "relatedStablecoins": "関連ステーブルコイン",
    "otcAverage": "OTC平均価格",
    "exchangeRate": "為替レート",
    "premiumRate": "プレミアム率",
    "copyFailed": "コピーできませんでした",
    "month": "か月",
    "day": "日",
    "hour": "時間",
    "minute": "分",
    "second": "秒",
    "back": "戻る",
    "apiKey": "APIキー",
    "secretKey": "シークレットキー",
    "passphrase": "パスフレーズ",
    "tradingChart": "DEXTools取引チャート",
    "requestFailed": "リクエストに失敗しました。再試行してください。",
    "networkError": "接続できません。ネットワークを確認して再試行してください。",
    "timeout": "リクエストがタイムアウトしました。再試行してください。",
    "sessionExpired": "セッションの有効期限が切れました。再度ログインしてください。",
    "walletDisconnected": "ウォレットの接続を解除しました",
    "connectWalletFirst": "先にウォレットを接続してください",
    "invalidAmount": "有効な金額を入力してください",
    "positiveAmount": "金額は0より大きい必要があります",
    "invalidSwap": "交換データが無効です。見積もりを再取得してください。",
    "swapFailed": "交換に失敗しました。取引状況を確認してください。",
    "serviceUnavailable": "サービスを一時的に利用できません",
    "tokenInfoFailed": "トークン情報を取得できませんでした",
    "walletNoAccount": "ウォレットからSolanaアカウントが返されませんでした",
    "walletUnsupported": "このウォレットは取引の署名と送信に対応していません",
    "walletNoSignature": "取引署名が返されませんでした。取引状況を確認してください。",
    "klineTime": "時刻：",
    "klineOpen": "始値：",
    "klineHigh": "高値：",
    "klineLow": "安値：",
    "klineClose": "終値：",
    "klineVolume": "出来高：",
    "klineTurnover": "売買代金：",
    "klineChange": "騰落率：",
    "walletLink": "ウォレットリンク"
  },
  "ko_KR": {
    "marketSummary": "Bitcoin 시장 요약",
    "trend24h": "24시간 추이",
    "past24h": "지난 24시간",
    "candleSummary": "BTC 종가: 최근 30분봉 48개",
    "historyPrice": "BTC 과거 가격 보기",
    "priceAt": "{time}, 가격 {price}",
    "scrubHint": "드래그하거나 방향키로 가격 확인",
    "chartUnavailable": "차트 데이터를 일시적으로 불러올 수 없습니다",
    "chartLoading": "차트 불러오는 중…",
    "btcRatio": "BTC 롱/숏 비율",
    "ratioShare": "롱 {long}% · 숏 {short}%",
    "marketSentiment": "시장 심리",
    "marketFocus": "시장 주요 정보",
    "exploreChains": "체인 살펴보기",
    "topAccountUnavailable": "{chain} 대규모 거래자 계정 비율 데이터가 없습니다",
    "topPositionUnavailable": "{chain} 대규모 거래자 포지션 비율 데이터가 없습니다",
    "previousValue": "이전 값",
    "actualValue": "발표 값",
    "usdtData": "USDT 데이터",
    "relatedStablecoins": "관련 스테이블코인",
    "otcAverage": "평균 장외 가격",
    "exchangeRate": "환율",
    "premiumRate": "프리미엄 비율",
    "copyFailed": "복사하지 못했습니다",
    "month": "개월",
    "day": "일",
    "hour": "시간",
    "minute": "분",
    "second": "초",
    "back": "뒤로",
    "apiKey": "API 키",
    "secretKey": "시크릿 키",
    "passphrase": "암호 문구",
    "tradingChart": "DEXTools 거래 차트",
    "requestFailed": "요청에 실패했습니다. 다시 시도해 주세요.",
    "networkError": "연결할 수 없습니다. 네트워크를 확인하고 다시 시도해 주세요.",
    "timeout": "요청 시간이 초과되었습니다. 다시 시도해 주세요.",
    "sessionExpired": "로그인이 만료되었습니다. 다시 로그인해 주세요.",
    "walletDisconnected": "지갑 연결이 해제되었습니다",
    "connectWalletFirst": "먼저 지갑을 연결해 주세요",
    "invalidAmount": "올바른 금액을 입력해 주세요",
    "positiveAmount": "금액은 0보다 커야 합니다",
    "invalidSwap": "스왑 데이터가 올바르지 않습니다. 견적을 다시 요청해 주세요.",
    "swapFailed": "스왑에 실패했습니다. 거래 상태를 확인해 주세요.",
    "serviceUnavailable": "서비스를 일시적으로 이용할 수 없습니다",
    "tokenInfoFailed": "토큰 정보를 불러올 수 없습니다",
    "walletNoAccount": "지갑에서 Solana 계정을 반환하지 않았습니다",
    "walletUnsupported": "이 지갑은 거래 서명 및 전송을 지원하지 않습니다",
    "walletNoSignature": "거래 서명이 반환되지 않았습니다. 거래 상태를 확인해 주세요.",
    "klineTime": "시간:",
    "klineOpen": "시가:",
    "klineHigh": "고가:",
    "klineLow": "저가:",
    "klineClose": "종가:",
    "klineVolume": "거래량:",
    "klineTurnover": "거래대금:",
    "klineChange": "등락률:",
    "walletLink": "지갑 링크"
  }
};
